export const ALL_COLLECTION_SLUG = 'all'
